import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '../views/About'
import ButtonPage from '../views/ButtonPage'
import ServicePage from '../views/ServicePage'
import ServiceDetailsPage from '../views/ServiceDetailsPage'
import CounterUpPage from '../views/CounterUpPage'
import ProgressbarPage from '../views/ProgressbarPage'
import AccordionPage from '../views/AccordionPage'
import SocialSharePage from '../views/SocialSharePage'
import BlogGridPage from '../views/BlogGridPage'
import BlogGridSidebarPage from '../views/BlogGridSidebarPage'
import BlogListPage from '../views/BlogListPage'
import BlogListSidebarPage from '../views/BlogListSidebarPage'
import BlogDetailsPage from '../views/BlogDetailsPage'
import BlogCategoryPosts from '../components/blog/BlogCategoryPosts'
import TeamPage from '../views/TeamPage'
import PortfolioPage from '../views/PortfolioPage'
import PortfolioThreeColumnPage from '../views/PortfolioThreeColumnPage'
import PortfolioFullWidthPage from '../views/PortfolioFullWidthPage'
import PortfolioGridLayoutPage from '../views/PortfolioGridLayoutPage'
import PortfolioBoxLayoutPage from '../views/PortfolioBoxLayoutPage'
import PortfolioDetailsPage from '../views/PortfolioDetailsPage'
import TestimonialPage from '../views/TestimonialPage'
import TimelinePage from '../views/TimelinePage'
import TabPage from '../views/TabPage'
import PricingPage from '../views/PricingPage'
import SplitSectionPage from '../views/SplitSectionPage'
import CallToActionPage from '../views/CallToActionPage'
import VideoPage from '../views/VideoPage'
import GalleryPage from '../views/GalleryPage'
import ContactPage from '../views/ContactPage'
import BrandPage from '../views/BrandPage'
import ErrorPage from '../views/404'
import AdvanceTabPage from '../views/AdvanceTabPage'
import BrandCarouselPage from '../views/BrandCarouselPage'
import AdvancePricingPage from '../views/AdvancePricingPage'
import BusinessConsulting from '../views/home-pages/BusinessConsulting'
import BusinessConsulting2 from '../views/home-pages/BusinessConsulting2'
import Corporate from '../views/home-pages/Corporate'
import Business from '../views/home-pages/Business'
import DigitalAgency from '../views/home-pages/DigitalAgency'
import Finance from '../views/home-pages/Finance'
import Company from '../views/home-pages/Company'
import MarketAgency from '../views/home-pages/MarketAgency'
import TravelAgency from '../views/home-pages/TravelAgency'
import Consulting from '../views/home-pages/Consulting'
import SeoAgency from '../views/home-pages/SeoAgency'
import PersonalPortfolio from '../views/home-pages/PersonalPortfolio'
import EventConference from '../views/home-pages/EventConference'
import CreativePortfolio from '../views/home-pages/CreativePortfolio'
import Freelancer from '../views/home-pages/Freelancer'
import InternationalConsulting from '../views/home-pages/InternationalConsulting'
import Startup from '../views/home-pages/Startup'
import WebAgency from '../views/home-pages/WebAgency'
import ProductAgency from "../views/home-site/ProductAgency";
import JoinUs from "../views/service-supports/JoinUs";
import ProductCustomization from "../views/service-supports/ProductCustomization";
import ProductServices from "../views/service-supports/ProductServices";
import ProductAfterSales from "../views/service-supports/ProductAfterSales";
import ProductRepair from "../views/service-supports/ProductRepair";
import Home from "../views/home-site/Home";
import HomeNewsDetails from "../views/home-site/HomeNewsDetails";
import ProductDownload from "../views/service-supports/ProductDownload";
import AboutCompany from "@/views/about-us/AboutCompany";
import AboutQualifications from "@/views/about-us/AboutQualifications";
import ContactUs from "@/views/about-us/ContactUs";
import HomeFull from "../views/home-site/HomeFull";
import HomeNewsList from "@/views/home-site/HomeNewsList";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: '首页',
        component: HomeFull,
        meta: {
            title: '耀协工贸',
        },
    },
    {
        path: '/button',
        name: 'Button',
        component: ButtonPage,
        meta: {
            title: 'Button | 耀协工贸',
        },
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: 'About | 耀协工贸',
        },
    },
    {
        path: '/service',
        name: 'Service',
        component: ServicePage,
        meta: {
            title: 'Service | 耀协工贸',
        },
    },
    {
        path: '/service-details',
        name: 'Service Details',
        component: ServiceDetailsPage,
        meta: {
            title: 'Service Details | 耀协工贸',
        },
    },
    {
        path: '/counter',
        name: 'Counter',
        component: CounterUpPage,
        meta: {
            title: 'Counter | 耀协工贸',
        },
    },
    {
        path: '/progressbar',
        name: 'Progressbar',
        component: ProgressbarPage,
        meta: {
            title: 'Progressbar | 耀协工贸',
        },
    },
    {
        path: '/accordion',
        name: 'Accordion',
        component: AccordionPage,
        meta: {
            title: 'Accordion | 耀协工贸',
        },
    },
    {
        path: '/social-share',
        name: 'Social share',
        component: SocialSharePage,
        meta: {
            title: 'Social Share | 耀协工贸',
        },
    },
    {
        path: '/blog-grid',
        name: 'Blog grid',
        component: BlogGridPage,
        meta: {
            title: 'Blog Grid | 耀协工贸',
        },
    },
    {
        path: '/blog-grid-sidebar',
        name: 'Blog grid sidebar',
        component: BlogGridSidebarPage,
        meta: {
            title: 'Blog Grid Sidebar | 耀协工贸',
        },
    },
    {
        path: '/blog-list',
        name: 'Blog list',
        component: BlogListPage,
        meta: {
            title: 'Blog List | 耀协工贸',
        },
    },
    {
        path: '/blog-list-sidebar',
        name: 'Blog list sidebar',
        component: BlogListSidebarPage,
        meta: {
            title: 'Blog List Sidebar | 耀协工贸',
        },
    },
    {
        path: '/blog-details/:id',
        name: 'Blog details',
        component: BlogDetailsPage,
        meta: {
            title: 'Blog Details | 耀协工贸',
        },
    },
    {
        path: '/category/:slug',
        name: 'Blog Category List',
        component: BlogCategoryPosts,
        meta: {
            title: 'Blog Category List | 耀协工贸',
        },
    },
    {
        path: '/team',
        name: 'Team',
        component: TeamPage,
        meta: {
            title: 'Team | 耀协工贸',
        },
    },
    {
        path: '/portfolio',
        name: 'Portfolio',
        component: PortfolioPage,
        meta: {
            title: 'Portfolio | 耀协工贸',
        },
    },
    {
        path: '/portfolio-three-column',
        name: 'Portfolio three column',
        component: PortfolioThreeColumnPage,
        meta: {
            title: 'Portfolio Three Column | 耀协工贸',
        },
    },
    {
        path: '/portfolio-full-width',
        name: 'Portfolio full width',
        component: PortfolioFullWidthPage,
        meta: {
            title: 'Portfolio Full Width | 耀协工贸',
        },
    },
    {
        path: '/portfolio-grid-layout',
        name: 'Portfolio grid layout',
        component: PortfolioGridLayoutPage,
        meta: {
            title: 'Portfolio Grid Layout | 耀协工贸',
        },
    },
    {
        path: '/portfolio-box-layout',
        name: 'Portfolio box layout',
        component: PortfolioBoxLayoutPage,
        meta: {
            title: 'Portfolio Box Layout | 耀协工贸',
        },
    },
    {
        path: '/portfolio-details/:id',
        name: 'Portfolio details',
        component: PortfolioDetailsPage,
        meta: {
            title: 'Portfolio Details | 耀协工贸',
        },
    },
    {
        path: '/testimonial',
        name: 'Testimonial',
        component: TestimonialPage,
        meta: {
            title: 'Testimonial | 耀协工贸',
        },
    },
    {
        path: '/timeline',
        name: 'Timeline',
        component: TimelinePage,
        meta: {
            title: 'Timeline | 耀协工贸',
        },
    },
    {
        path: '/tab',
        name: 'Tab',
        component: TabPage,
        meta: {
            title: 'Tab | 耀协工贸',
        },
    },
    {
        path: '/pricing',
        name: 'Pricing',
        component: PricingPage,
        meta: {
            title: 'Pricing | 耀协工贸',
        },
    },
    {
        path: '/spit-section',
        name: 'Split section',
        component: SplitSectionPage,
        meta: {
            title: 'Split Section | 耀协工贸',
        },
    },
    {
        path: '/call-to-action',
        name: 'Call to action',
        component: CallToActionPage,
        meta: {
            title: 'Call to Action | 耀协工贸',
        },
    },
    {
        path: '/video',
        name: 'Video',
        component: VideoPage,
        meta: {
            title: 'Video | 耀协工贸',
        },
    },
    {
        path: '/gallery',
        name: 'Gallery',
        component: GalleryPage,
        meta: {
            title: 'Gallery | 耀协工贸',
        },
    },
    {
        path: '/contact',
        name: 'Contact',
        component: ContactPage,
        meta: {
            title: 'Contact | 耀协工贸',
        },
    },
    {
        path: '/brand',
        name: 'Brand',
        component: BrandPage,
        meta: {
            title: 'Brand | 耀协工贸',
        },
    },
    {
        path: '/error',
        name: 'Error',
        component: ErrorPage,
        meta: {
            title: '404 | 耀协工贸',
        },
    },
    {
        path: '/advance-tab',
        name: 'Advance tab',
        component: AdvanceTabPage,
        meta: {
            title: 'Advance Tab | 耀协工贸',
        },
    },
    {
        path: '/brand-carousel',
        name: 'Brand carousel',
        component: BrandCarouselPage,
        meta: {
            title: 'Brand Carousel | 耀协工贸',
        },
    },
    {
        path: '/advance-pricing',
        name: 'Advance pricing',
        component: AdvancePricingPage,
        meta: {
            title: 'Advance Pricing | 耀协工贸',
        },
    },
    {
        path: '/portfolio-details',
        name: 'Portfolio details',
        component: PortfolioDetailsPage,
        meta: {
            title: 'Portfolio Details | 耀协工贸',
        },
    },
    {
        path: '/blog-details',
        name: 'Blog details',
        component: BlogDetailsPage,
        meta: {
            title: 'Blog Details | 耀协工贸',
        },
    },
    {
        path: '/business-consulting',
        name: 'Business Consulting',
        component: BusinessConsulting,
        meta: {
            title: 'Business Consulting | 耀协工贸',
        },
    },
    {
        path: '/business-consulting-2',
        name: 'Business Consulting 2',
        component: BusinessConsulting2,
        meta: {
            title: 'Business Consulting 2 | 耀协工贸',
        },
    },
    {
        path: '/corporate',
        name: 'Corporate',
        component: Corporate,
        meta: {
            title: 'Corporate | 耀协工贸',
        },
    },
    {
        path: '/business',
        name: 'Business',
        component: Business,
        meta: {
            title: 'Business | 耀协工贸',
        },
    },
    {
        path: '/digital-agency',
        name: 'Digital Agency',
        component: DigitalAgency,
        meta: {
            title: 'Digital Agency | 耀协工贸',
        },
    },
    {
        path: '/finance',
        name: 'Finance',
        component: Finance,
        meta: {
            title: 'Finance | 耀协工贸',
        },
    },
    {
        path: '/company',
        name: 'Company',
        component: Company,
        meta: {
            title: 'Company | 耀协工贸',
        },
    },
    {
        path: '/marketing-agency',
        name: 'Marketing Agency',
        component: MarketAgency,
        meta: {
            title: 'Marketing Agency | 耀协工贸',
        },
    },
    {
        path: '/travel-agency',
        name: 'Travel Agency',
        component: TravelAgency,
        meta: {
            title: 'Travel Agency | 耀协工贸',
        },
    },
    {
        path: '/consulting',
        name: 'Consulting',
        component: Consulting,
        meta: {
            title: 'Consulting | 耀协工贸',
        },
    },
    {
        path: '/seo-agency',
        name: 'SEO Agency',
        component: SeoAgency,
        meta: {
            title: 'SEO Agency | 耀协工贸',
        },
    },
    {
        path: '/personal-portfolio',
        name: 'Personal Portfolio',
        component: PersonalPortfolio,
        meta: {
            title: 'Personal Portfolio | 耀协工贸',
        },
    },
    {
        path: '/event-conference',
        name: 'Event Conference',
        component: EventConference,
        meta: {
            title: 'Event Conference | 耀协工贸',
        },
    },
    {
        path: '/creative-portfolio',
        name: 'Creative Portfolio',
        component: CreativePortfolio,
        meta: {
            title: 'Creative Portfolio | 耀协工贸',
        },
    },
    {
        path: '/freelancer',
        name: 'Freelancer',
        component: Freelancer,
        meta: {
            title: 'Freelancer | 耀协工贸',
        },
    },
    {
        path: '/international-consulting',
        name: 'International Consulting',
        component: InternationalConsulting,
        meta: {
            title: 'International Consulting | 耀协工贸',
        },
    },
    {
        path: '/startup',
        name: 'Startup',
        component: Startup,
        meta: {
            title: 'Startup | 耀协工贸',
        },
    },
    {
        path: '/web-agency',
        name: 'Web Agency',
        component: WebAgency,
        meta: {
            title: 'Web Agency | 耀协工贸',
        },
    },

    /********************************************************************************************/
    {
        path: '*',
        name: '404',
        component:  ErrorPage,
        meta: {
            title: '404 | 耀协工贸',
        },
    },
    {
        path: '/product-agency',
        name: '产品中心',
        component: ProductAgency,
        meta: {
            title: '产品中心 | 耀协工贸',
        },
    },
    {
        path: '/case-agency',
        name: '合作案例',
        component: ProductAgency,
        meta: {
            title: '合作案例 | 耀协工贸',
        },
    },

    /************************************服务支持********************************************/

    {
        path: '/join-us',
        name: '合作加盟',
        component: JoinUs,
        meta: {
            title: '合作加盟 | 耀协工贸',
        },
    },
    {
        path: '/product-customization',
        name: '产品定制',
        component: ProductCustomization,
        meta: {
            title: '产品定制 | 耀协工贸',
        },
    },
    {
        path: '/product-services',
        name: '生产服务',
        component: ProductServices,
        meta: {
            title: '生产服务 | 耀协工贸',
        },
    },
    {
        path: '/product-after-sales',
        name: '售后保障',
        component: ProductAfterSales,
        meta: {
            title: '售后保障 | 耀协工贸',
        },
    },
    {
        path: '/apply',
        name: '报修服务',
        component: ProductRepair,
        meta: {
            title: '报修服务 | 耀协工贸',
        },
    },
    {
        path: '/product-download',
        name: '下载中心',
        component: ProductDownload,
        meta: {
            title: '下载中心 | 耀协工贸',
        },
    },
    {
        path: '/news-details',
        name: '动态资讯',
        component: HomeNewsDetails,
        meta: {
            title: '动态资讯 | 耀协工贸',
        },
    },

    {
        path: '/news-list',
        name: '动态资讯',
        component: HomeNewsList,
        meta: {
            title: '动态资讯 | 耀协工贸',
        },
    },


    /************************************关于我们********************************************/

    {
        path: '/about-company',
        name: '公司简介',
        component: AboutCompany,
        meta: {
            title: '公司简介 | 耀协工贸',
        },
    },

    {
        path: '/about-agency',
        name: '资质证书',
        component: AboutQualifications,
        meta: {
            title: '资质证书 | 耀协工贸',
        },
    },


    {
        path: '/contact-us',
        name: '联系我们',
        component: ContactUs,
        meta: {
            title: '联系我们 | 耀协工贸',
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {

    console.log(to.matched.length);
    if (to.matched.length === 0) {
        next('/404')
    } else {
        next();
    }
    window.scrollTo(0, 0)
    document.title = to.meta.title;

});

export default router
